module.exports = __webpack_public_path__ + "static/media/glassBronze.c3c399d3.png";